<template>
    <div v-show="can.create.user">
        <button-primary @click="open">
            <template slot="icon"><i class="fa fa-plus"></i></template>
            User hinzufügen
        </button-primary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">User hinzufügen</template>

                <p class="mb-4 text-gray-500 text-sm">Der User wird direkt im System angelegt und kann verwaltet
                    werden.
                    Alternativ kann man den Nutzer auch nur einladen.
                </p>

                <input-text class="mb-4" v-model="email">E-Mail Adresse</input-text>

                <input-text class="mb-4" v-model="first_name">Vorname</input-text>

                <input-text class="mb-8" v-model="name">Name</input-text>

                <toggle-group class="mb-4" v-model="ignore_scim" v-if="can.update.scim">
                    Active Directory Verwaltung
                    <template v-slot:helper>
                        Der Nutzer wird von der Active Directory Verwaltung ausgeschlossen
                    </template>
                </toggle-group>

                <div class="flex justify-end">
                    <button-primary @click="create" v-show="!loading">
                        <template slot="icon"><i class="fa fa-plus"></i></template>
                        User hinzufügen
                    </button-primary>
                    <loading v-show="loading"></loading>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import Modal from "../Modal.vue";
import Headline from "../UI/Headline.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import InputText from "../UI/InputText.vue";
import Loading from "../UI/Loading.vue";
import Alert from "../UI/Alert.vue";
import ToggleGroup from "../UI/ToggleGroup.vue";

export default {
    name: "UserCreate",

    components: {
        ToggleGroup,
        Alert,
        Loading,
        InputText,
        ButtonPrimary,
        Headline,
        Modal,
        ButtonSecondary
    },

    data: () => ({
        showModal: false,
        loading: false,
        email: '',
        first_name: '',
        name: '',
        ignore_scim: false,
    }),

    inject: ['can'],

    methods: {
        open() {
            this.email = '';
            this.first_name = '';
            this.name = '';
            this.ignore_scim = false;
            this.showModal = true;
        },
        create() {
            this.loading = true;
            this.$http.post('/admin/users', {
                name: this.name,
                email: this.email,
                first_name: this.first_name,
                ignore_scim: this.ignore_scim,
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$root.$emit('alert', 'Benutzer erstellt.');
                this.$emit('created', this.email);
            }).catch(error => {
                this.$root.$emit('error', error);
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
